import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import api from '@/api';
import MaterialEdit from '../edit/index';
import MaterialAccountEdit from '../../materialAccount/edit/index';
export default {
  name: 'MaterialList',
  components: {
    MaterialEdit: MaterialEdit,
    MaterialAccountEdit: MaterialAccountEdit
  },
  data: function data() {
    return {
      isSelect: this.checkauthority('material_select'),
      isCreate: this.checkauthority('material_add'),
      isUpdate: this.checkauthority('material_edit'),
      isDelete: this.checkauthority('material_del'),
      isOptionUser: this.checkauthority('material_option_user'),
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      selectForm: {
        pushText: '',
        createTimes: []
      },
      editDisabled: false,
      dialogVisible: false,
      accountDisabled: false,
      accountDialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  methods: {
    getAllImages: function getAllImages(row) {
      var _this = this;
      try {
        var images = JSON.parse(row.images);
        return images.map(function (img) {
          return _this.downloadUrl + img.url;
        });
      } catch (e) {
        return [];
      }
    },
    openAccount: function openAccount() {
      this.accountDisabled = false;
      this.accountDialogVisible = true;
      this.$refs.account.initData();
    },
    accountClose: function accountClose() {
      this.accountDialogVisible = false;
    },
    dalete: function dalete(index, data) {
      var _this2 = this;
      this.$confirm('确定删除该素材吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return _this2.daleteApi(data);
      }).catch(function () {
        return _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(data) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.DELETE_MATERIAL({
                materialId: data.materialId
              });
            case 1:
              _this3.initTableData();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this4 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = _this4.tableSelects.map(function (e) {
          return e.materialId;
        });
        _this4.deleteBatchApi(par);
      }).catch(function () {
        return _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.DELETE_BATCH_MATERIAL(par);
            case 1:
              _this5.$message.success('操作成功');
              _this5.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑素材');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增素材');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.pushText = '';
      this.selectForm.createTimes = [];
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                pageNo: _this6.pageNo,
                pageSize: _this6.pageSize,
                pushText: _this6.selectForm.pushText
              };
              if (_this6.selectForm.createTimes && _this6.selectForm.createTimes.length > 1) {
                par.startCreateTime = _this6.selectForm.createTimes[0];
                par.endCreateTime = _this6.selectForm.createTimes[1];
              }
              _context3.n = 1;
              return api.GET_MATERIAL_PAGE_LIST(par);
            case 1:
              res = _context3.v;
              _this6.tableData = res.body.datas;
              _this6.pageTotal = res.body.sumDataCount;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) return;
    this.initTableData();
  }
};